import { ListRender } from "../../shared/components/base/list/ListRender";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ConfirmModalRender } from "../../shared/components/implementations/modal/ConfirmModalRender";
import { VentaDetailModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/VentaDetailModalRender";
import { VentaListItemRender } from "../../shared/components/modulos/pesaje/ganaderia/list/VentaListItemRender";
import { VentaModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/VentaModalRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import {
  fx_createVentaAnimalesRequest,
  fx_createVentaAnimalesRequestEmpty,
} from "../../shared/modulos/pesaje/ganaderia/request/VentaAnimalesRequest";
import { VentaAnimalesResponse } from "../../shared/modulos/pesaje/ganaderia/response/VentaAnimalesResponse";
import { VentaAnimalesDeleteGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/VentaAnimalesDeleteGrpcService";
import { fx_createVentaAnimalesGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/VentaAnimalesGrpcService";

/** Página de ventas (pesaje · ganadería): sección + lista de ventas de la finca
 *  activa. (Fase 1: solo lectura; alta/ver/editar/eliminar en fases siguientes.) */
export class VentasPage implements IPage {
  /** Lista de ventas (sección + filas). Se crea en `render` (ver nota). */
  private _list: ListRender<VentaAnimalesResponse> | null = null;

  /** Monta la sección/lista en el contenedor de la página.
   *  La lista se construye aquí (no en el constructor) porque `AppRender` llama
   *  `dispose()` de la página antes de `render()`; hacerlo en el constructor
   *  dejaría la lista disposed antes de cargar. */
  render(
    pageContent: HTMLDivElement,
    _secondSidebarWrapper: HTMLDivElement,
  ): void {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    this._list = new ListRender<VentaAnimalesResponse>({
      label: "PESAJE · GANADERÍA",
      title: "Ventas",
      subtitle: `${finca.nombreFinca} · Registro de ventas de animales`,
      addLabel: "Nueva venta",
      onAdd: () => new VentaModalRender(fx_createVentaAnimalesRequestEmpty()).init(),
      listService: fx_createVentaAnimalesGrpcService(finca.id),
      createItem: (venta) =>
        new VentaListItemRender(venta, {
          onView: (v) => new VentaDetailModalRender(v).init(),
          onEdit: (v) =>
            new VentaModalRender(fx_createVentaAnimalesRequest(v)).init(),
          onDelete: (v) =>
            new ConfirmModalRender({
              title: "Eliminar venta",
              message: `¿Está seguro que desea eliminar la venta <strong>${v.codigo ?? ""}</strong> de <strong>${finca.nombreFinca}</strong>? Esta acción no se puede deshacer.`,
              onConfirm: async () => {
                await new VentaAnimalesDeleteGrpcService().deleteAsync(v);
                serviceProvider.getLayoutService().reload();
              },
            }).init(),
        }),
      emptyMessage: "Sin ventas registradas",
    });

    pageContent.innerHTML = this._list.render();
    this._list.connect();
  }

  /** Dispone la lista. */
  dispose(): void {
    this._list?.dispose();
    this._list = null;
  }
}
